import AuthService from '../services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    refreshToken({ commit }, accessToken) {
      commit('refreshToken', accessToken);
    },
    sendOtp({ commit }, data) {
      return AuthService.sendOtp(data).then(
        response => {
          commit('sendOtpSuccess');
          return Promise.resolve(response);
        },
        error => {
          commit('sendOtpFailure');
          return Promise.reject(error);
        }
      );
    },
    loginOtp({ commit }, user) {
      return AuthService.loginOtp(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    loginGoogle({ commit }, data) {
      console.log('loginGoogle', data);
      return AuthService.loginGoogle(data).then(
        data => {
          commit('loginSuccess', data);
          return Promise.resolve(data);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    changePasscode({ commit }, user) {
      return AuthService.changePasscode(user).then(
        user => {
          console.log(commit);
          return Promise.resolve(user);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    refreshToken(state, accessToken) {
      state.status.loggedIn = true;
      state.user = { ...state.user, accessToken: accessToken };
    },
    sendOtpSuccess(state) {
      state.status.loggedIn = false;
    },
    sendOtpFailure(state) {
      state.status.loggedIn = false;
    }
  }
};
